import { restService } from "./RestService";

export class ConfigurationService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    async getCountries() {
        const url = `${this.baseUrl}/configuration/countries`;

        try {
            return await restService.get(url);
        } catch (error) {
            this.handleError(error, "Unable to load the list of countries - please see server logs for more details");
        }
    }

    handleError = (error, message) => {
        throw new Error(message, { cause: error });
    };
}
